import {
  UserAttributeIdentifierEnum,
  AttributeEnum
} from 'src/app/enums/enums';
import { UserAttributes } from './user-attribute/user-attribute';

export class User {
  readonly ccpUserAttributes: UserAttributes;
  readonly riskTechDataUserAttributes: UserAttributes;

  constructor(eaObject: any) {
    this.ccpUserAttributes = new UserAttributes(
      eaObject[UserAttributeIdentifierEnum.CCP]
    );
    this.riskTechDataUserAttributes = new UserAttributes(
      eaObject[UserAttributeIdentifierEnum.RiskTechData]
    );
  }

  // Made this a static function for now to address a bug in the user service worker
  static isInternal(user: User): boolean {
    const isExternal = UserAttributes.getValuesByAttribute(
      user.ccpUserAttributes,
      AttributeEnum.IsExternal
    );
    return isExternal === 'false';
  }

  // Made this a static function for now to address a bug in the user service worker
  static hasRTDataAccess(user: User): boolean {
    const apps: string[] | undefined = UserAttributes.getValuesByAttribute(
      user.ccpUserAttributes,
      AttributeEnum.Applications
    );
    return !!apps?.some((x) => x === 'RISKTECHDATA');
  }
}
